<template>
	<div class="pages" @click="selectFn(-1)">
		<HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView></HeaderView>
		<NavView @selectId="selectFn" ref="column" @oneClick="oneClick"></NavView>
		<!-- 	<div class="banner">
					<img src="@/assets/images/banner.png" alt srcset />
				</div> -->
		<div class="word">
			<!-- 条件输入 -->
			<div class="condition" v-if="selectList.length > 0">
				<div class="condition_box" v-for="(item,index) in selectList" :key="index" v-if="item.screen == 1" :ref="`list${index}`"
				 :class="listLength % 4 === 0 ? 'list4' : listLength % 4 === 1 ? 'list1' : listLength % 4 === 2 ? 'list2' : listLength % 4 === 3 ? 'list3' : ''">
					<div class="condition_text">{{item.columnName}}</div>
					<div class="input_box">
						<input class="condition_input" type="text" v-model="item.input" />
					</div>
				</div>
			</div>
			<div class="search_btn" @click="searchData" v-if="selectList.length != 0">{{$t('search.search')}}</div>
			<!-- 产品列表 -->
			<div v-if="data.length > 0" class="table">
				<el-table :data="data" stripe style="width: 100%" @cell-click="detalis" border>
					<el-table-column prop="productNum" :label="$t('publicText.model')" width="130" header-align="center" align="center">
					</el-table-column>
					<el-table-column v-for="(item,index) in selectList" :label="item.columnName" :key="index" header-align="center"
					 align="center">
						<template slot-scope="scope">
							<div>{{scope.row[`column${item.columnId}`] ? scope.row[`column${item.columnId}`] : '---'}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-else class="noData">{{ $t('publicText.noData') }}</div>
			<!-- <div class="product_box">
				<div class="product_list" v-for="(item,index) in data" :key="index">
					<div class="product_img">
						<img :src="$img+item.productImg.split(',')[0]" alt />
					</div>
					<div class="product">
						<div class="product-name">{{item.productName}}</div>
						<div class="product-t">{{$t('search.model')}}：{{item.productNum}}</div>
						<div class="product-t">{{$t('search.stock')}}：{{item.stock}}</div>
						<div class="product-price product-t">{{$t('search.Price')}}：<span>${{item.unitPrice / 100}}</span></div>
						<div class="product-detail " @click="detalis(item.productId)">
							<button>{{$t('search.details')}}</button>
						</div>
					</div>
				</div>
			</div>-->

			<el-pagination layout="prev,pager,next" :page-size="pageSize" @current-change="handleCurrentChange" :total="totleNum"
			 v-if="data.length > 0"></el-pagination>

		</div>
		<Footer></Footer>
	</div>
</template>
<script>
	import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
	import HeaderView from "@/components/assembly/Header.vue"; //头部模块
	import NavView from "@/components/assembly/Nav.vue"; //导航模块
	import Footer from "@/components/assembly/Footer.vue"; //导航模块
	export default {
		data() {
			return {
				num: "1",
				searchList: [], //搜索
				lang: localStorage.getItem("lang"),
				selectList: [],
				listLength: 0, //搜索列表的长度
				pageNum: 1,
				pageSize: 20,
				totleNum: 50,
				searchDatas: {}, //填入的搜索内容
				columnId: "", //主键ID
				data: [], //产品
			};
		},
		components: {
			HeaderTopView,
			NavView,
			Footer,
			HeaderView
		},
		methods: {
			detalis(item) {
				// console.log(item)
				this.$router.push({
					path: "/GoodsDetails",
					query: {
						id: item.productId
					}
				});
			},
			//获取详细搜索
			findSearch() {
				this.selectList = []
				this.$get("/open/product/column", {
					language: this.lang,
					catalogId: this.columnId
					// screen: 1
				}).then(res => {
					res.data.map(item => {
						if ((item.columnComment == 'text' || item.columnComment == 'number') && (item.screen == 1 || item.listType ==
								1)) {
							this.selectList.push(item)
						}
					})
					this.listLength = this.selectList.length;
					res.data.forEach(element => {
						element.input = "";
					});
					this.goodsList()
				});

			},
			//获取产品列表
			goodsList() {
				// console.log(this.searchDatas, "this.searchDatas")
				this.$post("/open/product/productList", {
					language: this.lang,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					catalogId: this.columnId,
					params: this.searchDatas
				}).then(res => {
					res.data.map((item, index) => {
						item.unitPrice = '$' + item.unitPrice / 100
						item.startBuy = item.startBuy == null ? '---' : item.startBuy
						item.goodsLoop = item.goodsLoop == null ? '---' : item.goodsLoop
						for (let i in item.product) {
							// console.log(i.slice(6))
							// console.log(item.product[i])
							this.selectList.map(items => {
								if (items.columnId == i.slice(6)) {
									item[i] = item.product[i]
								}
							})
						}
					})
					// console.log(res.data)
					this.data = res.data
					this.totleNum = res.params.total
				});
			},
			//搜索
			searchData() {
				let data = {}
				this.selectList.forEach(element => {
					if (element.input) {
						let key = `column${element.columnId}`
						data[key] = element.input
					}
				});
				this.searchDatas = data
				this.goodsList()
			},
			handleCurrentChange(e) {
				this.pageNum = e;
				this.goodsList()
			},
			//下拉搜索
			selectFn(e) {
				if (e == -1) {
					this.$refs.column.goodsList = false
					return false
				}
				this.$refs.column.goodsList = false
				this.columnId = e
				this.findSearch();
			},
			oneClick(e) {
				this.columnId = e
				this.findSearch();
			}
		},
		mounted() {
			// this.columnId = this.$route.query.id
			// this.findSearch();
		}
	};
</script>
<style scoped>
	.table {
		margin-top: 20px;
	}

	.table>>>.el-table th {
		color: #fff !important;
		background: linear-gradient(0deg, #0573CB 0%, #3F9FEA 100%);
		padding: 1px;
		font-size: 12px;
	}

	.table>>>.el-table th div {
		line-height: 20px !important;
	}

	.table>>>.el-table td {
		padding: 1px;
		font-size: 12px
	}

	.table>>>.el-table__row:hover {
		color: #0090ff;
		cursor: pointer;
	}

	ul {
		list-style: none;
		padding: 0;
	}

	.noData {
		color: #999;
		padding: 50px;
		text-align: center;
		font-size: 16px
	}

	.product-t {
		color: #1A1A1A;
		font-size: 13px;
		margin: 10px 0;
		display: flex;
		font-weight: bold;
	}

	.product .product-name {
		font-size: 14px !important;
		color: #089ecc;
		margin: 18px 0;
		display: flex !important;
	}

	.product .product-price>span {
		color: #D03B3B;
		font-weight: bold;
		font-size: 16px;
	}

	.product .product-detail {
		display: flex;
	}

	.product .product-detail>button {
		color: white;
		/* background-color: #2381c9; */
		width: 76px;
		height: 26px;
		text-align: center;
		line-height: 26px;
		background: -webkit-linear-gradient(#3F9FEA, #0A77CE);
		/* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(#3F9FEA, #0A77CE);
		/* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(#3F9FEA, #0A77CE);
		/* Firefox 3.6 - 15 */
		background: linear-gradient(#3F9FEA, #0A77CE);
		/* 标准的语法 */
	}

	.product_box .product_list .product_text .product_details {
		background: -webkit-linear-gradient(#3f9fea, #0a77ce);
		/* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(#3f9fea, #0a77ce);
		/* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(#3f9fea, #0a77ce);
		/* Firefox 3.6 - 15 */
		background: linear-gradient(#3f9fea, #0a77ce);
		/* 标准的语法 */
		width: 76px;
		height: 26px;
		color: #eeeeee;
		font-size: 14px;
		text-align: center;
		line-height: 26px;
		margin: 8px 0;
	}

	.product_box .product_list .product_text .text_box .money_box .money {
		color: #d03b3b;
		font-size: 16px;
		font-weight: bold;
	}

	.product_box .product_list .product_text .text_box .money_box .money_text {
		color: #1a1a1a;
		font-size: 13px;
		font-weight: bold;
		line-height: 21px;
	}

	.product_box .product_list .product_text .text_box .money_box {
		display: flex;
	}

	.product_box .product_list .product_text .text_box .attribute {
		color: #1a1a1a;
		font-size: 13px;
		font-weight: bold;
		margin: 8px 0;
	}

	.product_box .product_list .product_text .text_box>li {
		display: flex;
	}

	.product_box .product_list .product_text .text_box .Title {
		color: #1680d3;
		font-size: 14px;
		font-weight: bold;
		margin: 17px 0;
	}

	.product_box .product_list .product_text .text_box {
		text-align: center;
	}

	.product_box .product_list .product_text {
		width: 60%;
	}

	.product_box .product_list .product_img>img {
		object-fit: cover;
		width: 104px;
		height: 104px;
	}

	.product_box .product_list .product_img {
		width: 40%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.product_box .product_list {
		width: 385px;
		height: 203px;
		border: 1px solid #e2e2e2;
		display: flex;
		margin-bottom: 25px;
		margin-right: 22px;
		box-sizing: border-box;
	}

	.product_box .product_list:nth-child(3n) {
		margin-right: 0;
	}

	.product_box {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.condition {
		padding: 0 20px;
		margin-top: 20px;
	}

	.condition .dashed {
		border-bottom: 1px dashed #e2e2e2;
		height: 1px;
		width: 1105px;
		margin: 0 auto;
		position: absolute;
		margin: auto;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;

	}

	.condition .condition_box .condition_text {
		line-height: 24px;
		/* width: 30%; */
		display: flex;
		align-items: center;
		text-align: center;
	}

	.condition .condition_box {
		border-bottom: 1px dashed #e2e2e2;
	}

	/* .condition .condition_box:nth-last-child(2),.condition .condition_box:nth-last-child(1),.condition .condition_box:nth-last-child(3),.condition .condition_box:nth-last-child(4){
			border-bottom: 0;
		} */
	.condition_box.list4:nth-last-child(1),
	.condition_box.list4:nth-last-child(2),
	.condition_box.list4:nth-last-child(3),
	.condition_box.list4:nth-last-child(4) {
		border: 0;
	}

	.condition_box.list3:nth-last-child(1),
	.condition_box.list3:nth-last-child(2),
	.condition_box.list3:nth-last-child(3) {
		border: 0;
	}

	.condition_box.list2:nth-last-child(1),
	.condition_box.list3:nth-last-child(2) {
		border: 0;
	}

	.condition_box.list1:nth-last-child(1) {
		border: 0;
	}

	.search_btn {
		width: 76px;
		height: 26px;
		border-radius: 5px;
		background: linear-gradient(0deg,
			rgba(63, 159, 234, 1) 0%,
			rgba(10, 119, 206, 1) 100%);
		margin-bottom: 20px;
		color: #fff;
		line-height: 26px;
		cursor: pointer;
	}

	.input_box {
		display: flex;
		align-items: center;
		/* width: 70%; */
		margin-top: 5px;
	}

	.condition .condition_box .condition_input {
		width: 86px;
		height: 22px;
		border: 1px solid #e3e3e3;
		/* margin-left: 15px; */
		font-size: 14px;
		color: #4a4a4a;
	}

	.condition .condition_box {
		display: flex;
		flex-direction: column;
		padding: 10px 0;
		/* flex: 1; */
		width: 14%;
		justify-content: center;
		align-items: center;
	}

	.condition {
		background-color: #f7f7f7;
		border: 1px solid rgba(226, 226, 226, 1);
		display: flex;
		width: 100%;
		flex-wrap: wrap;
		position: relative;
		margin-bottom: 28px;
	}

	.pages {
		background: #fff;
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}

	.word {
		margin-bottom: 20px;
		flex: 1;
	}

	div {
		box-sizing: border-box;
	}

	.banner {
		width: 100%;
		height: 400px;
	}

	.banner img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.search_box {
		width: 100%;
		display: flex;
		padding: 0 50px;
		border: 1px solid #e2e2e2;
		background: #f7f6f9;
	}

	.search-list-item {
		height: 70px;
	}

	.select_box {
		margin-top: 18px;
		padding: 0 30px;
		background-color: #e2e2e2;
	}

	.select_item {
		height: 35px;
	}
</style>



// WEBPACK FOOTER //
// src/components/goodsCenter/GoodsCenter.vue